// Stores the JWT token
let token: string | null = null

export function setToken(newToken: string): void {
    token = newToken
}

export function getToken(): string | null {
    return token
}

export function clearToken(): void {
    token = null
}

/**
 * Drops the `token` query parameter from the address bar once the JWT is in
 * memory. Until it is removed the full URL, JWT included, is sent as the
 * `Referer` on every subsequent request. Using replaceState avoids adding a
 * history entry or re-triggering the SPA router.
 */
export function stripTokenFromUrl(): void {
    if (typeof window === 'undefined' || !window.history?.replaceState) {
        return
    }

    const url = new URL(window.location.href)
    if (!url.searchParams.has('token')) {
        return
    }

    url.searchParams.delete('token')
    window.history.replaceState(
        window.history.state,
        '',
        `${url.pathname}${url.search}${url.hash}`
    )
}
